import { createSelector } from 'reselect';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';
import { getPropertyValueByPath } from "../../../../../../react-table/helpers/utils";
import { getReportMode, getReportState } from "../../../../../common/redux/selectors/ReportsSelectors";
import CarditNestingLocationData from "../../containers/CarditNestingLocationData";
import CarditNestingLocationColumns from "../../containers/CarditNestingLocationColumns";

export const COLUMN_ACCESSOR_CONSIGNMENT_TOTAL = 'consignment.total';
export const COLUMN_ACCESSOR_RECEPTACLES_TOTAL = 'receptacles.total';

export const HEADER_CONSIGNMENT = 'consignment';
export const HEADER_RECEPTACLES = 'receptacles';

export const COLUMN_LEAF_EXCLUSIONS = ['carrier'];

export const PROPERTY_ORIGINAL_GRAND_TOTAL = 'originalGrandTotal';
export const PROPERTY_ORIGINAL_GROUP_TOTAL = 'originalGroupTotal';

export const getGeneratedOnDateTime =
  state => state.reporting.CARDIT_NESTING_LOCATION.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.CARDIT_NESTING_LOCATION.isLoading;

export const getIsFiltered = state => state.reporting.CARDIT_NESTING_LOCATION.filtering &&
  state.reporting.CARDIT_NESTING_LOCATION.filtering.appliedFilters &&
  state.reporting.CARDIT_NESTING_LOCATION.filtering.appliedFilters.some(filter => !filter.value.clearFilter);

export const getData =
  ReportDefinitions.CARDIT_NESTING_LOCATION.getDataFunction();

export const getOriginalGrandTotal = state => state.reporting.CARDIT_NESTING_LOCATION.data
  .map(row => getPropertyValueByPath(row, COLUMN_ACCESSOR_RECEPTACLES_TOTAL)[0])
  .reduce((grandTotal, groupTotal) => grandTotal + groupTotal, 0);

export const getColumns =
  createSelector(
    getData,
    state => state.reporting.CARDIT_NESTING_LOCATION.requestParams,
    state => getReportMode(state, ReportDefinitions.CARDIT_NESTING_LOCATION.id),
    CarditNestingLocationColumns,
  );

export const getFilteredAndSortedData =
  createSelector(
    state => getReportState(state, ReportDefinitions.CARDIT_NESTING_LOCATION.id),
    getColumns,
    CarditNestingLocationData,
  );
